import type { Path } from "react-router-dom";

// ! do not reuse params on different routes; especially with useEffects
// #region Route Params
export const WELL_ID_NAME_PARAM = "wellIdName";
export const FAILURE_MODE_EFFECT_PARAM = "failureModeEffect";
// #endregion

// #region System Overview Routes
export const OVERVIEW_ROUTE_SEGMENT = "overview";
export const OVERVIEW_ROUTE = `/${OVERVIEW_ROUTE_SEGMENT}`;

export const OVERVIEW_ROUTE_CHARTS_SEGMENT = "charts";
export const OVERVIEW_ROUTE_CHARTS = `${OVERVIEW_ROUTE}/${OVERVIEW_ROUTE_CHARTS_SEGMENT}`;

export const OVERVIEW_ROUTE_CHARTS_OPERATIONAL_SEGMENT = "operational";
export const OVERVIEW_ROUTE_CHARTS_OPERATIONAL = `${OVERVIEW_ROUTE_CHARTS}/${OVERVIEW_ROUTE_CHARTS_OPERATIONAL_SEGMENT}`;

export const OVERVIEW_ROUTE_CHARTS_INTERVENTION_SEGMENT = "intervention";
export const OVERVIEW_ROUTE_CHARTS_INTERVENTION = `${OVERVIEW_ROUTE_CHARTS}/${OVERVIEW_ROUTE_CHARTS_INTERVENTION_SEGMENT}`;

export const OVERVIEW_ROUTE_TABLES_SEGMENT = "tables";
export const OVERVIEW_ROUTE_TABLES = `${OVERVIEW_ROUTE}/${OVERVIEW_ROUTE_TABLES_SEGMENT}`;

export const OVERVIEW_ROUTE_TABLES_WELL_SEGMENT = "well";
export const OVERVIEW_ROUTE_TABLES_WELL = `${OVERVIEW_ROUTE_TABLES}/${OVERVIEW_ROUTE_TABLES_WELL_SEGMENT}`;

export const OVERVIEW_ROUTE_TABLES_RISK_SEGMENT = "risk";
export const OVERVIEW_ROUTE_TABLES_RISK = `${OVERVIEW_ROUTE_TABLES}/${OVERVIEW_ROUTE_TABLES_RISK_SEGMENT}`;

export const OVERVIEW_ROUTE_TABLES_KLF_SEGMENT = "klf";
export const OVERVIEW_ROUTE_TABLES_KLF = `${OVERVIEW_ROUTE_TABLES}/${OVERVIEW_ROUTE_TABLES_KLF_SEGMENT}`;

export const OVERVIEW_ROUTE_TABLES_KCF_SEGMENT = "kcf";
export const OVERVIEW_ROUTE_TABLES_KCF = `${OVERVIEW_ROUTE_TABLES}/${OVERVIEW_ROUTE_TABLES_KCF_SEGMENT}`;

export const OVERVIEW_ROUTE_MAP_SEGMENT = "map";
export const OVERVIEW_ROUTE_MAP = `${OVERVIEW_ROUTE}/${OVERVIEW_ROUTE_MAP_SEGMENT}`;

export const OVERVIEW_ROUTE_MAP_HYBRID_SEGMENT = "hybrid";
export const OVERVIEW_ROUTE_MAP_HYBRID = `${OVERVIEW_ROUTE_MAP}/${OVERVIEW_ROUTE_MAP_HYBRID_SEGMENT}`;

export const OVERVIEW_ROUTE_MAP_SATELLITE_SEGMENT = "satellite";
export const OVERVIEW_ROUTE_MAP_SATELLITE = `${OVERVIEW_ROUTE_MAP}/${OVERVIEW_ROUTE_MAP_SATELLITE_SEGMENT}`;
// #endregion

// #region Risk Management Routes
export const RISK_ROUTE_SEGMENT = "risk";
export const RISK_ROUTE = `/${RISK_ROUTE_SEGMENT}`;

export const RISK_ROUTE_CHARTS_SEGMENT = "charts";
export const RISK_ROUTE_CHARTS = `${RISK_ROUTE}/${RISK_ROUTE_CHARTS_SEGMENT}`;

export const RISK_ROUTE_CHARTS_OVERALL_SEGMENT = "overall";
export const RISK_ROUTE_CHARTS_OVERALL = `${RISK_ROUTE_CHARTS}/${RISK_ROUTE_CHARTS_OVERALL_SEGMENT}`;

export const RISK_ROUTE_CHARTS_MAJOR_SEGMENT = "major";
export const RISK_ROUTE_CHARTS_MAJOR = `${RISK_ROUTE_CHARTS}/${RISK_ROUTE_CHARTS_MAJOR_SEGMENT}`;

export const RISK_ROUTE_CHARTS_MITIGATION_SEGMENT = "mitigation";
export const RISK_ROUTE_CHARTS_MITIGATION = `${RISK_ROUTE_CHARTS}/${RISK_ROUTE_CHARTS_MITIGATION_SEGMENT}`;

export const RISK_ROUTE_TABLES_SEGMENT = "tables";
export const RISK_ROUTE_TABLES = `${RISK_ROUTE}/${RISK_ROUTE_TABLES_SEGMENT}`;
// #endregion

// #region Other Routes
export const LOGIN_ROUTE_SEGMENT = "login";
export const LOGIN_ROUTE = `/${LOGIN_ROUTE_SEGMENT}`;
export const LOGOUT_ROUTE_SEGMENT = "logout";
export const LOGOUT_ROUTE = `/${LOGOUT_ROUTE_SEGMENT}`;

export const RELOG_ROUTE_SEGMENT = "relog";
export const RELOG_ROUTE = `/${RELOG_ROUTE_SEGMENT}`;

export const LOGIN_ERROR_ROUTE_SEGMENT = "login-error";
export const LOGIN_ERROR_ROUTE = `/${LOGIN_ERROR_ROUTE_SEGMENT}`;
// #endregion

// #region Export Route
export const EXPORT_ROUTE_SEGMENT = "export";
export const EXPORT_ROUTE = `/${EXPORT_ROUTE_SEGMENT}`;
// #endregion

// #region Config Route
export const CONFIG_ROUTE_SEGMENT = "config";
export const CONFIG_ROUTE = `/${CONFIG_ROUTE_SEGMENT}`;

export const CONFIG_LH_ROUTE_SEGMENT = "lh";
export const CONFIG_LH_ROUTE = `${CONFIG_ROUTE}/${CONFIG_LH_ROUTE_SEGMENT}`;

export const CONFIG_IMPORT_DATA_ROUTE_SEGMENT = "import";
export const CONFIG_IMPORT_ROUTE = `${CONFIG_LH_ROUTE}/${CONFIG_IMPORT_DATA_ROUTE_SEGMENT}`;

export const CONFIG_ATTRIBUTE_MAPPING_ROUTE_SEGMENT = "mapping";
export const CONFIG_ATTRIBUTE_MAPPING_ROUTE = `${CONFIG_LH_ROUTE}/${CONFIG_ATTRIBUTE_MAPPING_ROUTE_SEGMENT}`;

export const CONFIG_DISPLAY_OPTIONS_ROUTE_SEGMENT = "display";
export const CONFIG_DISPLAY_OPTIONS_ROUTE = `${CONFIG_LH_ROUTE}/${CONFIG_DISPLAY_OPTIONS_ROUTE_SEGMENT}`;
// #endregion

export const DEFAULT_ROUTE = OVERVIEW_ROUTE_CHARTS_OPERATIONAL;

export const ROUTE_HEADINGS: Record<Path["pathname"], string> = {
  "/": "Home",
  [OVERVIEW_ROUTE]: "System Overview",
  [RISK_ROUTE]: "Risk Management",
  [EXPORT_ROUTE]: "Export",
  [CONFIG_ROUTE]: "Configuration",
  [CONFIG_LH_ROUTE]: "Lighthouse",
};
